const routes = require('next-routes');

module.exports = routes()
  .add({
    name: 'login',
    pattern: '/login',
    page: 'auth/login',
  })
  .add({
    name: 'explore-categories-show',
    pattern: '/categories/:categoryId(\\d+)',
    page: 'explore/categories/show',
  })
  .add({
    name: 'explore-areas-show',
    pattern: '/categories/:categoryId(\\d+)/areas/:areaId(\\d+)',
    page: 'explore/areas/show',
  })
  .add({
    name: 'explore-stations-show',
    pattern: '/categories/:categoryId(\\d+)/stations/:originalStationId(\\d+)',
    page: 'explore/stations/show',
  })
  .add({
    name: 'explore-categories-index',
    pattern: '/categories',
    page: 'explore/categories/index',
  })
  .add({
    name: 'merchant-blog-show',
    pattern: '/:publicId/blogs/:blogId(\\d+)',
    page: 'merchants/blogs/show',
  })
  .add({
    name: 'merchant-blog',
    pattern: '/:publicId/blogs',
    page: 'merchants/blogs/index',
  })
  .add({
    name: 'merchant-booking_pages',
    pattern: '/:publicId/booking_pages',
    page: 'merchants/resources/index',
  })
  .add({
    name: 'merchant-reviews',
    pattern: '/:publicId/reviews',
    page: 'merchants/reviews/index',
  })
  .add({
    name: 'merchant-services',
    pattern: '/:publicId/services',
    page: 'merchants/services/index',
  })
  .add({
    name: 'merchant-product-details',
    pattern: '/:publicId/products/:productId(\\d+)',
    page: 'merchants/products/show',
  })
  .add({
    name: 'merchant-product-purchase',
    pattern: '/:publicId/products/:productId(\\d+)/purchase',
    page: 'merchants/products/purchases/show',
  })
  .add({
    name: 'merchant-products',
    pattern: '/:publicId/products',
    page: 'merchants/products/index',
  })
  .add({
    name: 'merchant-resources-book',
    pattern: '/:publicId/:resource_id(\\d+)/book',
    page: 'merchants/resources/books/show',
  })
  .add({
    name: 'merchant-resources-book-express',
    pattern: '/:publicId/:resource_id(\\d+)/express',
    page: 'merchants/resources/books/express/show',
  })
  .add({
    name: 'merchant-resources',
    pattern: `/:publicId/:resource_id(\\d+)`,
    page: 'merchants/resources/show',
  })
  .add({
    name: 'merchant-about',
    pattern: '/:publicId/about',
    page: 'merchants/about',
  })
  .add({
    name: 'merchant-details',
    pattern: '/:publicId',
    page: 'merchants/show',
  })
  .add({
    name: 'explore-index',
    pattern: '/',
    page: 'explore/index',
  })
  .add({
    name: 'merchant-widget-calendar',
    pattern: '/:publicId/widget/calendar/:servicePublicIds',
    page: 'merchants/widget/calendar',
  })
  .add({
    name: 'merchant-widget-calendar-all',
    pattern: '/:publicId/widget/calendar',
    page: 'merchants/widget/calendar',
  });
